// extracted by mini-css-extract-plugin
export default {"accessTag":"Tag_accessTag__+qx24","gray":"Tag_gray__Y-Bg3","blue":"Tag_blue__LBJEm","green":"Tag_green__0+t28","wrapper":"Tag_wrapper__ACQ6t","default":"Tag_default__yr1c2"};